import { Skeleton } from '@shared/components/shadcn';
import { LotteryHeaderContainer } from '../../LotteryHeaderContainer/LotteryHeaderContainer';
import { LotteryLayout } from '../../lotteries/LotteryLayout/LotteryLayout';
import type { LotteryName } from '../../lottery-purchases/types';
import { LIVE_DRAW_PANEL_CLASSES } from '../components/LiveDrawPanel/liveDrawClasses';
import { LiveDrawPromoSkeleton } from './LiveDrawPromoSkeleton';

type ResultsHeaderSkeletonProps = {
  lotteryName: LotteryName;
  /**
   * Reserves the waiting-stage promotion instead of the results number row.
   *
   * The next draw has not loaded, so the stage is unknown. A normal visit opens on
   * `selling_countdown` or `previous_result`, which both show the promotion. The grid is a
   * different height, and `LiveDrawPanel` switches to it once the stage is known.
   */
  isLiveDrawView?: boolean;
};

function DateSelectorSkeleton() {
  return (
    <div className="w-full bg-white/10 backdrop-blur-sm border border-current/20 rounded-lg p-3 flex items-center justify-between">
      <Skeleton className="h-5 w-48 bg-current/15" />
      <Skeleton className="h-4 w-4 bg-current/15" />
    </div>
  );
}

function ResultsHeaderSkeleton({ lotteryName, isLiveDrawView = false }: ResultsHeaderSkeletonProps) {
  return (
    <LotteryHeaderContainer lotteryName={lotteryName} className="ll-grid-container h-auto py-8 px-4 xl:py-10 xl:px-0">
      <LotteryLayout
        lotteryName={lotteryName}
        className="ll-container-inner flex flex-col gap-y-4"
        isHeader
        isLiveDrawView={isLiveDrawView}
        showArchivePanel
        activeContent={
          isLiveDrawView ? (
            <div className={LIVE_DRAW_PANEL_CLASSES}>
              <LiveDrawPromoSkeleton lotteryName={lotteryName} />
            </div>
          ) : undefined
        }
      >
        <div data-testid="results-header-skeleton" className="flex flex-col gap-y-4">
          <DateSelectorSkeleton />
          {isLiveDrawView ? null : (
            <div className="bg-white rounded-full px-4 py-3 flex items-center justify-center md:justify-start gap-2 border border-gray-200">
              {Array.from({ length: 6 }, (_, index) => (
                <Skeleton key={index} className="size-7 rounded-full flex-shrink-0" />
              ))}
            </div>
          )}
        </div>
      </LotteryLayout>
    </LotteryHeaderContainer>
  );
}

export { ResultsHeaderSkeleton, type ResultsHeaderSkeletonProps };
